import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "@/data/site";
import { FAQ as TIDS } from "@/constants/testIds";
import { useLiveStats } from "@/lib/liveStats";

export default function FAQ({ items = FAQS }) {
  const [open, setOpen] = useState(0);
  const stats = useLiveStats();
  const sub = (t) => (t || "").replaceAll("{{count}}", String(stats.total));
  return (
    <section
      id="faq"
      data-testid={TIDS.section}
      className="py-28 md:py-40 bg-stone-50"
    >
      <div className="max-w-[980px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16 md:mb-20">
          <p className="overline mb-7">Questions answered</p>
          <h2 className="font-serif text-[2.8rem] sm:text-[3.6rem] md:text-[4.8rem] leading-[1.02] tracking-tight text-stone-900">
            Questions Essex couples
            <br />
            <em className="italic font-normal text-stone-600">ask most.</em>
          </h2>
        </div>

        <div className="divide-y divide-stone-200">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                data-testid={TIDS.item(i)}
                className="py-8"
              >
                <button
                  className="w-full flex items-start justify-between gap-8 text-left group"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`${TIDS.item(i)}-toggle`}
                  aria-expanded={isOpen}
                >
                  <h3 className="font-serif text-[1.45rem] md:text-[1.75rem] text-stone-900 leading-snug pr-4">
                    {sub(f.q)}
                  </h3>
                  <span className="flex-shrink-0 mt-1.5 text-stone-500 group-hover:text-stone-900 transition-colors">
                    {isOpen ? (
                      <Minus className="w-5 h-5" strokeWidth={1} />
                    ) : (
                      <Plus className="w-5 h-5" strokeWidth={1} />
                    )}
                  </span>
                </button>
                {isOpen && (
                  <p className="mt-5 font-serif text-stone-700 text-[1.15rem] leading-[1.65] pr-12 fade-up max-w-2xl">
                    {sub(f.a)}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
